import DynamicProductCarousel from '@src/components/DynamicProductCarousel'
import { FC } from 'react'
import {
  CarouselProduct,
  CarouselProductTypes,
} from '@src/components/DynamicProductCarousel/DynamicProductCardTypes'
import useResponsiveSizes from '@src/utils/useResponsiveSizes'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface RecommendedProductsProps {
  products: CarouselProduct[]
}

const RecommendedProducts: FC<RecommendedProductsProps> = ({ products }) => {
  const theme = useTheme()
  const getSize = useResponsiveSizes()

  const isMobile = useMediaQuery(theme.breakpoints.down('lg'), {
    defaultMatches: true,
  })

  return products?.length ? (
    <DynamicProductCarousel
      type={CarouselProductTypes.RecommendedProducts}
      products={products}
      withoutControls={!isMobile}
      slidesToShow={getSize({ xs: 1, sm: 2, lg: 3 })}
      preloadCardImages
      condensed
    />
  ) : null
}

export default RecommendedProducts
